function Hero () {
    return(
        <div className="hero">
            <h1>HOME</h1>
        </div>
    );
}

export default Hero;